import { EmployeesService, DeclarationService } from "../../services/index";

export const timesheetsState: aboTheme.IState = {
    parent: "app",
    name: "timesheets",
    url: "/timesheets",
    redirectTo: "timesheets.dashboard",
    component: "timesheetsComponent",
    data: {
        permissions: {
            only: ['TIMESHEETS'],
            redirectTo: 'schedule'
        }
    }
};

export const timesheetsDashboardState: aboTheme.IState = {

    name: "timesheets.dashboard",
    url: "/dashboard",
    resolve: {        
        employees: (EmployeesService: EmployeesService, $stateParams: ng.ui.IStateParamsService) => { 
            "ngInject"; 
            var moment = require('moment');

            var startDate = moment().startOf('isoweek').toDate();
            var endDate = moment().endOf('isoweek').toDate();

            return EmployeesService.customAll('employeeSummary', {from: startDate, till: endDate});
        }
    },
    views: {
        "main": 'timesheetsDashboardComponent'
    }
};

export const timesheetsOverviewState: aboTheme.IState = {

    name: "timesheets.overview",
    url: "/overview?employeeId",
    resolve: { 
    },
    views: {
        "main": 'timesheetsOverviewComponent'
    },
    data: {
        permissions: {
            only: ['FINANCE'],
            redirectTo: 'timesheets'
        }
    }
};

export const timesheetsDeclarationState: aboTheme.IState = {

    name: "timesheets.dashboard.declaration",
    url: "/declaration/:declarationId?employeeId&shiftId&type&shiftStartDate&shiftEndDate",
    params: {
        employeeId: null,
        shiftId: null,
        type: null,
        shiftStartDate: null,
        shiftEndDate: null
    },
    modal: true,
    resolve: {
        wageCodes: (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('HourCodes'); },
        declaration: (DeclarationService: DeclarationService, $stateParams: ng.ui.IStateParamsService) => {
            "ngInject";
            if ($stateParams['declarationId']) {
                return DeclarationService.get($stateParams['declarationId']);
        }
    },
    },
    component: 'declarationComponent'
};


// WEBPACK FOOTER //
// ./src/app/modules/timesheets/timesheets.states.ts